import "./faqs.js";
import "./faqs.scss";


// WEBPACK FOOTER //
// ./resources/views/library/patterns/faqs/index.js